export const notEmpty = (value) => {
    return value !== null && value !== undefined;
};
